export const GA_MEASUREMENT_ID = 'G-YLPL1NMJQP';
export const CURRENT_TERMS_VERSION = '2026-06-08';

const DONATION_DEDUPE_KEY = 'ga_donation_txns';
const LAST_DONATION_KEY = 'ga_last_donation';

function gtagSafe(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

export function grantAnalyticsConsent() {
  gtagSafe('consent', 'update', { analytics_storage: 'granted' });
}

export function denyAnalyticsConsent() {
  gtagSafe('consent', 'update', { analytics_storage: 'denied' });
}

export function trackPageView(path, title) {
  gtagSafe('event', 'page_view', {
    page_path: path,
    page_title: title || (typeof document !== 'undefined' ? document.title : ''),
  });
}

export function trackEvent(name, params = {}) {
  gtagSafe('event', name, params);
}

export function setUserId(pseudonymousId) {
  if (!pseudonymousId) return;
  gtagSafe('set', { user_id: pseudonymousId });
}

export function setUserIdFromUsername(username) {
  if (!username) return;
  setUserId(username.split('').reverse().join(''));
}

export function trackLogin(method = 'standard') {
  trackEvent('login', { method });
  trackEvent('login_user', { method });
}

export function trackSignUp(specialty) {
  const params = {};
  if (specialty) params.specialty = specialty;
  trackEvent('sign_up', params);
  trackEvent('register_user', params);
}

export function storeLastDonation({ transactionId, premiumGranted, donationSource }) {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(
    LAST_DONATION_KEY,
    JSON.stringify({
      transaction_id: transactionId,
      premium_granted: Boolean(premiumGranted),
      donation_source: donationSource || 'unknown',
    })
  );
}

export function getLastDonation() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    return JSON.parse(sessionStorage.getItem(LAST_DONATION_KEY) || 'null');
  } catch {
    return null;
  }
}

export function trackDonationComplete({ transactionId, premiumGranted, donationSource }) {
  const txnId = (transactionId || '').trim();
  if (!txnId) return false;

  let sent = [];
  try {
    sent = JSON.parse(sessionStorage.getItem(DONATION_DEDUPE_KEY) || '[]');
  } catch {
    sent = [];
  }

  if (sent.includes(txnId)) return false;

  trackEvent('donation_complete', {
    transaction_id: txnId,
    premium_granted: Boolean(premiumGranted),
    donation_source: donationSource || 'unknown',
  });

  sent.push(txnId);
  sessionStorage.setItem(DONATION_DEDUPE_KEY, JSON.stringify(sent.slice(-50)));
  return true;
}

export function trackWebVital({ name, value, id }) {
  trackEvent('web_vital', {
    metric_name: name,
    value: Math.round(name === 'CLS' ? value * 1000 : value),
    metric_id: id,
  });
}

export function pathToFeatureName(path) {
  return (path || '').replace(/^\//, '').replace(/-/g, '_') || 'main';
}
